import { useAuth0 } from "@auth0/auth0-react";

export default function Login() {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
loginWithRedirect({
  appState: { returnTo: "/profile" },
  authorizationParams: { audience: "https://someet-api" },
});

  };

  return <button onClick={handleLogin}>Zaloguj</button>;
}